@use '~/vendor/cxy/scss/styles/index.scss' as cxy;

.filtersWall {
  position: relative;
  font-size: var(--cxy-fontSize-xs);
}

.fadedContent {
  pointer-events: none;
  opacity: 0.15;
}

.contentWrapper {
  position: absolute;
  top: 25%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  @include cxy.stack(var(--cxy-spacing-xxsm));
  justify-content: center;
  align-items: center;
}

.textWrapper {
  text-align: center;
}
.textWrapper > span {
  line-height: var(--cxy-lineHeight-xs);
  font-size: var(--cxy-fontSize-s);
  vertical-align: middle;
  padding-bottom: var(--cxy-spacing-0);
}

.ghostButton {
  color: var(--cxy-color-brand);
  font-size: var(--cxy-fontSize-s);
  font-weight: var(--cxy-fontWeight-semiBold);
}

.svg {
  color: var(--cxy-color-brand);
  height: var(--cxy-icon-size-sm);
  width: var(--cxy-icon-size-sm);
}
.svg path {
  stroke: var(--cxy-color-brand);
}
